<template>
<div>
    <el-dialog title="请选择零件" width="60%" :visible.sync="viewData.visible" append-to-body>
        <el-table :data="dataList" row-key="id" size="small" bProject style="width: 100%" :default-expand-all="false" @current-change="currentChange" @selection-change="selectionChangeHandle" border :header-cell-style="{background:'#f5f5f5'}" class="mb15">
            <el-table-column label="选择" type="selection" width="55">
                <template slot-scope="scope">
                    <input type="checkbox" v-model="partList" :value="scope.row.id" />
                </template>
            </el-table-column>
            <el-table-column type="index" width="50" label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                </template>
            </el-table-column>
            <el-table-column prop="partCode" header-align="center" align="left" label="零件编号">
            </el-table-column>
            <el-table-column prop="partName" header-align="center" align="left" label="零件名称">
            </el-table-column>
            <el-table-column prop="unit" header-align="center" align="center" label="单位">
            </el-table-column>
            <el-table-column prop="oneCarCount" header-align="center" align="right" label="单车用量">
            </el-table-column>
            <el-table-column prop="targetPrice" header-align="center" align="right" label="目标价格">
            </el-table-column>
            <el-table-column prop="supplyStatus" header-align="center" align="center" label="建议货源">
            </el-table-column>
            <el-table-column prop="targetInvestment" header-align="center" align="center" label="目标工装费">
            </el-table-column>
            <el-table-column prop="targetDevelopment" header-align="center" align="center" label="目标开发费">
            </el-table-column>
            <el-table-column prop="targetTestfee" header-align="center" align="center" label="目标试验费">
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" style="text-align: right" class="mb15">
        </el-pagination>
        <el-row :gutter="40">
            <el-col :span="24" style="text-align: right">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <!-- 询价中 -->
                <el-button size="small" type="primary" @click="confirm()">
                    确认
                </el-button>
            </el-col>
        </el-row>
    </el-dialog>
</div>
</template>

<script>
import {
    getPartList,
    getTaskPartIdsByTaskId,
    updateTaskApparmentByIds
} from "@/controller/tech";
import moment from "moment";
import {
    DIALOG_CLOSED_TYPE
} from "@/utils/const";
export default {
    data() {
        return {
            documentClientHeight: document.documentElement["clientHeight"] - 250,
            dataForm: {
                // 零件表里的字段
                id: "",
                taskId: "",
                technicalId: "",
                appartmentCode: "",
                partName: "",
                unit: "",
                oneCarCount: "",
                targetPrice: "",
                supplyStatus: "",
                remark: "",
            },
            taskId: '',
            dataList: [],
            tenantList: [],
            partList: [],
            firstPartList: [],
            result: '',
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            viewData: {
                visible: false,
                width: "",
            },
            userList: [],
            currentRow: {},
        };
    },
    mounted() {},
    activated() {
        // this.getDataList();
    },
    methods: {

        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        // 获取数据列表
        getDataList(technicalId) {
            // console.log(this.getDataList)
            this.dataListLoading = true;
            this.dataList = []
            getPartList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                ...this.dataForm,
                technicalId: technicalId,
                isTaskIdNull: true,
            }).then((data) => {
                // console.log(data, "data");
                if (data && data.code === "00") {
                    this.dataList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.totalPage = 0;
                }
                this.dataListLoading = false;
            });
        },
        // 获取数据列表
        getPurchaseTaskApparment(taskId) {
            // console.log(this.getDataList)
            this.taskId = taskId
            this.dataListLoading = true;
            this.partList = []
            getTaskPartIdsByTaskId({}, taskId).then((data) => {
                // console.log(data, "data");
                if (data && data.code === "00") {
                    // 初始零件Id备份
                    this.partList = data.body;
                    this.firstPartList = this.partList.slice()
                }
                this.dataListLoading = false;
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        currentChange(currentRow) {
            console.log(currentRow);
            this.currentRow = currentRow;
        },
        open(technicalId, taskId) {
            this.viewData.visible = true;
            this.getDataList(technicalId);
            // 提取当前任务下零件
            this.getPurchaseTaskApparment(taskId);
        },
        onClosed(params) {
            console.log(params);
            return;
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }
            this.onClosed({
                option,
                sender: this,
                data: this.result,
            });
            this.viewData.visible = false;
        },
        confirm() {
            // 保存partList零件 调用批量添加
            const _this = this
            let diffPartList = this.partList.filter(function (val) {
                return _this.firstPartList.indexOf(val) === -1
            })
            updateTaskApparmentByIds({
                taskId: this.taskId,
                ids: diffPartList
            }).then((data) => {
                if (data && data.code === "00") {
                    this.result = "OK"
                    this.$message({
                        message: "零件添加成功",
                        type: "success",
                    });
                    this.close(DIALOG_CLOSED_TYPE.CONFIRM);
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.mb15 {
    margin-bottom: 15px;
}
</style>
